import {Injectable} from '@angular/core';


@Injectable({providedIn: 'root'})
export class LoginModalService {
    private isOpen = false;

    open(): void {
        // if (this.isOpen) {
        //   return;
        // }
        // this.isOpen = true;
        // this.modalRef = this.modalService.open(JhiLoginModalComponent);
        // this.modalRef.result.then(
        //   result => {
        //     this.isOpen = false;
        //   },
        //   reason => {
        //     this.isOpen = false;
        //   }
        // );
        // return this.modalRef;
    }

    close() {
        // if (this.isOpen && this.modalRef) {
        //   this.modalRef.close();
        // }
    }
}
